import React from 'react';
import { createPortal } from 'react-dom';
import Form from 'react-bootstrap/Form';
import { Col, Container, Row, Button } from 'react-bootstrap';
import ChemComponent from '../ChemComponent';
import { withRouter } from '../withRouter';
import ChemEdit from '../ChemEdit';
import { Link } from 'react-router-dom';
import { Search } from 'react-bootstrap-icons';
import PartsModal from './PartsModal';

class PartSignOut extends ChemComponent {
	constructor(props) {
		super(props);

		this.state = {
			job: {
				shop_job: {
					JOB_ID: '',
					SHOP_ID: props.params.shopId,
					STATUS_ID: 7,
					JOB_REF: 'Part Sign Out'
				},
				shop_job_pi: {},
				shop_job_rch: [{}],
				shop_job_estimate: {},
				shop_job_labor: [],
				shop_job_material: [{
					PART_QTY: 1,
					JOB_DATE: this.dateTimeToMVC(new Date())
				}],
				job_scope: {
					JOB_SCOPE: '',
					JOB_NOTES: '',
					COMMENTS: ''
				},
				job_doc: [],
				job_comment: []
			},
			jobColumns: this.copyColumns(jobColumns),
			showPartSearch: false,
			partSearchProps: null,
			editable: true,
			renderKey: 0
		}
	}	
		
	onChange(accessor, value) {
		var newState = {
			job: this.copyObject(this.state.job)
		};
		this.setByAccessor(newState.job, accessor, value);
		if (Array.isArray(accessor) && accessor.includes('shop_job_pi.PI_ROLE')) {
			for (var i = 0; i < accessor.length; i++) {
				if (accessor[i] === 'shop_job_pi.PI_ROLE') {
					newState.jobColumns = this.copyColumns(jobColumns);
					var ccIdx = this.findColumnByAccessor(newState.jobColumns, 'shop_job_rch[0].SPEEDTYPE');
					newState.jobColumns[ccIdx].options.search = { Attribute: 'ROLE_ID', Operator: '=', LongValue: value[i] };
					break;
				}
			}
		}
		this.mergeState(newState);
	}
	
	validateJob(event, columns, data) {
		return this.validate(columns, data);
	}

	onSubmit(event) {
		var self = this;
		var i;
		
		var job = this.copyObject(this.state.job);
		this.js2mvc(job, jobColumns);

		// if the customer was entered in free text
		if (this.isEmpty(job.shop_job_pi.CUSTOMER_ID) &&
			!this.isEmpty(job.shop_job_pi.CUSTOMER_NAME)) {
			// put name in correct place to be saved
			job.shop_job_pi.OTHER_CUST = job.shop_job_pi.CUSTOMER_NAME;
		}
		
		// Create an object of formData
		const formData = new FormData();

		// add the token to the formData
		formData.append('__RequestVerificationToken', this.props.user.antiForgeryToken);			

		// add the job to the formData
		var nvpairs = this.createHiddenFormData({ job: job });
		for (i = 0; i < nvpairs.length; i++) {
			formData.append(nvpairs[i].name, nvpairs[i].value);
		}

		this.ajax({
			type: 'POST',
			url: this.getConfig().host + '/Jobtrack/UpdateJob',
			data: formData,
			contentType: false,
			processData: false,
			overlay: true,
		}).done(function (data) {
			if (data.Success) {
				self.props.parent.showConfirmation(() => {
					var jobId = self.props.params.jobId || data.ID;
					var verb = self.props.params.jobId ? "updated" : "created";
					return (<>
						Job <Link to={'/Jobtrack/Jobs/' + jobId}>{jobId}</Link> {verb}.
					</>);
				});				
			} else {
				self.showAlert('Server Error', data.Message);
			}			
		}).fail(function (jqXHR, textStatus, errorThrown) {
			self.showAlert('Server Error', 'Server returned a status of ' + jqXHR.status);
		});
	}
	
	renderPartSearch(props) {
	  var self = this;
	  
	  return(
		<PartsModal parent={this} user={this.props.user} onClose={(accessor, value) => {
			var newState = {
				job: self.copyObject(self.state.job)
			};
			if (accessor !== undefined && accessor !== null) {
				self.setByAccessor(newState.job.shop_job_material[0], accessor, value);
			}
			newState.showPartSearch = false;
			newState.partSearchProps = null;
			self.mergeState(newState);
		}} />
	  );
	}

	render() {		
		return (<>
			<Container fluid>
			  <Row>
			    <Col style={{ paddingTop: '20px', paddingBottom: '10px', border: '1px solid #ccc', backgroundColor: '#FEFEFE' }}>
				  <Container fluid>
					<Row>
					  <Col>
						<div style={{ fontSize: '18px', fontWeight: 'bold', marginBottom: '10px' }}>
							Sign Out Part
						</div>
					  </Col>
					</Row>
					<Row>
					  <Col style={{ paddingBottom: '10px' }}>
						<ChemEdit parent={this} user={this.props.user} columns={this.state.jobColumns} data={this.state.job}
							onChange={(accessor, value) => this.onChange(accessor, value)} renderKey={this.state.renderKey}
							onSubmit={(event) => this.onSubmit(event)} editable={this.state.editable}>
							<Form.Group as={Row}>
							  <Col style={{ borderTop: '1px solid #eee', paddingTop: '5px' }}>
								<Button id="save" variant="warning" type="submit" className="float-end">Save</Button>
							  </Col>
							</Form.Group>							
						</ChemEdit>
					  </Col>
					</Row>
				  </Container>
				</Col>
			  </Row>
			</Container>
			{this.state.showPartSearch && createPortal(this.renderPartSearch(this.state.partSearchProps), document.body)}
		</>);
	}
}

const jobColumns = [
	{ Header: 'PI', valueAccessor: 'shop_job_pi.PI_ROLE', accessor: 'shop_job_pi.OTHER_PI', type: 'dropdown', row: 0, col: 0, required: true,
		options: { value: 'ROLE_ID', label: 'PI_NAME', entity: 'RECHARGES.JOB_EDIT_PI_SELECT_VW', order: 'PI_NAME',
			search: { Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' }}},
	{ Header: 'Speedtype', accessor: 'shop_job_rch[0].SPEEDTYPE', 
		labelAccessor: ['shop_job_rch[0].SPEEDTYPE','shop_job_rch[0].PI_NAME','shop_job_rch[0].DESCRIPTION'], 
		type: 'multicolumn', allowEntry: true, row: 0, col: 1, required: true,
		options: { value: 'SPEEDTYPE', label: ['SPEEDTYPE','PI_NAME','DESCRIPTION'],
			entity: 'RECHARGES.JOB_SPEEDTYPE_DROPDOWN_VW', order: ['PI_NAME','SPEEDTYPE'], 
				search: { Attribute: 'ROLE_ID', Operator: '=', LongValue: 0 }}},
	{ Header: 'Customer', accessor: 'shop_job_pi.CUSTOMER_ID', labelAccessor: ['shop_job_pi.CUSTOMER_NAME','shop_job_pi.EMAIL',
		'shop_job_pi.LOCATION','shop_job_pi.OFFICE_PHONE'], type: 'multicolumn', row: 1, col: 0, required: true,
		allowEntry: 'Use customer name as entered (other fields will not be saved)',
		options: { value: 'ROLE_ID', label: ['CUSTOMER_NAME','EMAIL','LOCATION','OFFICE_PHONE'], entity: 'RECHARGES.JOB_CUST_DROPDOWN_VW',
			order: 'CUSTOMER_NAME', search: { Attribute: 'ACTIVE_FLAG', Operator: '=', StringValue: 'Y' }}},
	{ Header: 'Status', accessor: 'shop_job.STATUS_ID', type: 'select', row: 1, col: 1, required: true,
		options: { value: 'STATUS_ID', label: 'STATUS_NAME', entity: 'RECHARGES.JOB_STATUS', order: 'STATUS_NAME',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Description', accessor: 'shop_job.JOB_REF', row: 2, col: 0, required: true },
	{ Header: 'Shop', accessor: 'shop_job.SHOP_ID', labelAccessor: 'shop_job.SHOP_NAME', type: 'select', row: 2, col: 1, required: true,
		options: { value: 'SHOP_ID', label: 'SHOP_NAME', entity: 'RECHARGES.SHOPS',
			search: { Attribute: 'DELETE_FLAG', Operator: 'is null' }}},
	{ Header: 'Part Name', accessor: 'shop_job_material[0].PART_NAME', row: 3, col: 0 },
	{ Header: 'Search for Part', accessor: 'shop_job_material[0].PART_NAME', row: 3, col: 1,
		Cell: props => <Button style={{ marginTop: '-8px' }} id="partSearch" variant="warning" type="button"
			onClick={() => props.parent.mergeState({ 
				showPartSearch: true, 
				partSearchProps: {
					accessor: props.accessor,
					value: props.value
				}})}><Search /></Button> },
	{ Header: 'Qty', accessor: 'shop_job_material[0].PART_QTY', row: 4, col: 0, required: true },
	{ Header: 'Issue Date', accessor: 'shop_job_material[0].JOB_DATE', type: 'date', row: 4, col: 1, required: true },
	{ Header: 'Job Comments', accessor: 'shop_job.COMMENTS', type: 'textarea', row: 5, col: 0, colwidth: 12 }
];

export default withRouter(PartSignOut);
